import { LoanType, Transaction, TransactionState } from './types'
import { moneyRound } from '../format'

export const computeState = (
  type: LoanType,
  tr: Transaction,
  state: TransactionState
): TransactionState => {
  if (state.closedOn != null) {
    return state
  }

  // Up here because of typing error
  if (tr.type === 'INIT') {
    return {
      amount: tr.amount,
      interest: tr.interest,
      latestUpdate: tr.createdOn,
      loanedAmount: tr.amount,
      closedOn: null,
      createdOn: tr.createdOn
    }
  }

  if (state.latestUpdate == null || state.createdOn == null) {
    throw new Error('State was not initialized')
  }

  switch (tr.type) {
    case 'CLOSE':
      return {
        ...state,
        closedOn: tr.createdOn,
        latestUpdate: tr.createdOn,
        amount: 0
      }
    case 'PAYMENT':
      if (type === LoanType.INTERVAL) {
        return {
          ...state,
          amount: moneyRound(state.amount - tr.amount)
        }
      }

      const daysCount = tr.createdOn.diff(state.latestUpdate, 'day')
      const principal = state.loanedAmount * (daysCount * state.interest / 100 / 365)
      const amount = moneyRound(state.amount + principal - tr.amount)

      return {
        ...state,
        amount,
        closedOn: amount <= 0 ? tr.createdOn : null,
        latestUpdate: tr.createdOn
      }
    case 'INTERVAL_INTEREST':
      if (type !== LoanType.INTERVAL) {
        throw new Error()
      }

      const interest = state.amount * state.interest / 100 / 365 * tr.interval

      return {
        ...state,
        amount: moneyRound(state.amount + interest)
      }
    default:
      throw new Error('')
  }
}



// WEBPACK FOOTER //
// ./src/utils/transactions/computeState.tsx